export const getLowerCasedCategories = (
  colorScheme: Record<string, string>,
) => {
  const lowerCasedCategories: Record<string, string> = {};
  Object.entries(colorScheme).forEach(([category, color]) => {
    lowerCasedCategories[category.toLowerCase()] = color;
  });

  return lowerCasedCategories;
};
